<template>
  <div class="col-12 col-md-12 col-lg-10">
    <div class="tit text-center">
      <h1>Já estamos terminando</h1>
      <p>Agora vou precisar dos dados bancários de vocês.</p>
    </div>
    <div class="row justify-content-center">
      <bank-data-form :bank-data="bankData" @submit="handleSubmit"/>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .btns {
    margin-top: 20px;
  }

</style>

<script>
  import BankDataForm from '@/components/BankDataForm'

  export default {
    components: { BankDataForm },
    props: {
      solicitacao: {required: true, type: Object}
    },
    computed: {
      bankData: function() {
        const bankData = this.solicitacao.Empresa.DadosBancarios || {}
        return {
          bankCode: bankData.CodigoBanco,
          agency: bankData.Agencia,
          account: bankData.Conta,
          accountType: bankData.TipoConta,
        }
      }
    },
    methods: {
      handleSubmit(formData) {
        this.$emit('on-submit', {
          Empresa: {
            DadosBancarios: {
              CodigoBanco: formData.bankCode,
              Agencia:     formData.agency,
              Conta:       formData.account,
              TipoConta:   formData.accountType
            },
            NaoTemContaBancaria: formData.hasNoAccount
          }
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationPeerToPeer/BankDataStep.vue